<template>
  <el-container>
    <el-header>
      <div class="header">
        <div class="inner container">
          <div class="logo">
            <router-link to="/">
              <img src="../assets/logo.png" alt=""
            /></router-link>
          </div>
          <el-menu
            :default-active="$router.currentRoute.path"
            mode="horizontal"
            @select="handleSelect"
            :router="true"
          >
            <el-menu-item index="/admaster">广告主榜单</el-menu-item>
            <el-menu-item index="/ad-material">广告素材</el-menu-item>
            <el-menu-item index="/adideas">爆款文案</el-menu-item>
            <el-menu-item index="/industry">行业分析</el-menu-item>
          </el-menu>
          <div class="search-container">
            <el-input
              placeholder="输入品牌/广告主/广告关键词等"
              v-model="searchText"
            >
              <template slot="append">
                <span class="search-btn" @click="search"> 搜索 </span>
              </template>
            </el-input>
          </div>
          <div class="user">
            <div v-if="!$root.isLogin">
              <router-link
                class="login-btn"
                :to="{ path: '/login', query: { from: $route.path } }"
                >登录</router-link
              >
              <!-- <router-link class="register-btn" to="/register">注册</router-link> -->
            </div>
            <div v-else class="user-info">
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ userInfo.username }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <!-- <a @click="dialogVisible = true">用户中心</a> -->
                    <router-link
                      style="text-decoration: none; color: #666"
                      to="/user"
                      >用户中心</router-link
                    >
                  </el-dropdown-item>
                  <el-dropdown-item divided>
                    <a @click="logout">退出</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <el-container class="account-bg-container">
      <el-main><router-view /></el-main>
      <div class="account-bg" v-if="showUserStatus">
        <div class="account-tip">
          <p>
            {{ userInfo.msg }}
          </p>
          <a
            class="account-tip-btn"
            href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
            target="_blank"
            >联系客服</a
          >
        </div>
      </div>
    </el-container>
    <Footer></Footer>
  </el-container>
</template>
<script>
import Footer from "../components/Footer";
export default {
  name: "Base",
  components: { Footer },
  mounted() {
    let isLogin = window.localStorage.getItem("isLogin");
    if (isLogin == "1") {
      this.$root.isLogin = true;
      this.queryUserINfo();
    } else {
      this.$root.isLogin = false;
    }
    window.addEventListener("keypress", this.enterSearch);
    this.$root.status = parseInt(window.localStorage.getItem("status"));
    console.log(this.$root.status);
    if (this.$root.status != 1) {
      this.showUserStatus = true;
    } else {
      this.showUserStatus = false;
    }
  },
  data() {
    return {
      userInfo: {},
      dialogVisible: false,
      searchText: "",
      showUserStatus: false,
    };
  },
  methods: {
    enterSearch(e) {
      if (e.keyCode == 13) {
        this.search();
      }
    },
    handleClose() {
      this.showUserStatus = false;
    },
    search() {
      if (this.searchText == "") {
        return;
      }
      console.log("搜索词：" + this.searchText + "，开始搜索");
      if (this.$route.path != "/search") {
        this.$router.push("/search?kw=" + this.searchText);
      } else {
        this.$eventBus.$emit("searchMsg", this.searchText);
      }
    },
    logout() {
      let session = localStorage.getItem("session");
      window.localStorage.removeItem("isLogin");
      window.localStorage.removeItem("session");
      window.localStorage.removeItem("status");
      this.$root.isLogin = false;
      console.log(this.$root);
      let http = this.$http.create();
      http.defaults.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
      http.post("/fireeye/account/logout?session=" + session).then((res) => {
        console.log(res);
        this.$router.push("/login");
      });
    },
    handleSelect() {},
    queryUserINfo() {
      this.$http.get("/fireeye/account/info").then((res) => {
        console.log(res);
        let data = res.data;
        if (data.code == 1) {
          this.userInfo = data.data;
          this.$root.status = this.userInfo.status;
          window.localStorage.setItem(
            "status",
            this.userInfo.status.toString()
          );
        } else {
          console.log("获取用户信息失败");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-header {
  padding: 0;
  position: fixed;
  width: 100%;
  z-index: 999;
  background-color: #fff;
}
.el-dropdown-menu {
  li {
    a {
      display: block;
    }
  }
}
.header {
  border-bottom: solid 1px #e6e6e6;

  .inner {
    display: flex;

    .logo {
      line-height: 60px;
      img {
        width: 140px;
        height: 40px;
        vertical-align: middle;
        margin: auto 0;
      }
    }

    .el-menu {
      border-bottom-width: 0;

      .el-menu-item {
        font-size: 18px;
      }
    }
    .search-container {
      flex: 1;
      margin: auto;
      padding: 0 80px;

      .el-input-group__append {
        padding: 0;
        background-color: #2196f3;
        color: #fff;
        cursor: pointer;
        .search-btn {
          cursor: pointer;
          padding: 12px 20px;
        }
      }
    }
    .user {
      line-height: 60px;

      a {
        display: inline-block;
        padding: 0 20px;
        text-decoration: none;
        font-weight: 400;
        font-size: 14px;
        color: #000;
      }

      .login-btn:hover {
        border-bottom: 2px solid #000;
      }
    }
  }
}
.el-main {
  margin-top: 80px;
}
.footer {
  overflow: hidden;
  background-color: #05061b;
  font-family: PingFangSC-Medium, PingFang SC;

  .footer-logo {
    width: 250px;
    height: 70px;
    margin: 32px auto 0;
  }

  .footer-title {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
    margin: 46px 0 24px 0;
  }

  .nav {
    text-align: left;

    .nav-link,
    .info {
      display: block;
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      margin-bottom: 16px;
    }
    .info {
      margin-bottom: 16px;
    }
  }

  .site-info {
    font-weight: 400;
    text-align: center;
    margin: 80px auto 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    line-height: 20px;

    a {
      text-decoration: none;
      color: #ffffff;
    }
  }
}
.userinfo-dialog {
  text-align: left;
  .label {
    display: inline-block;
    width: 70px;
    color: #999;
    font-weight: 600;
  }
  .value {
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }
}
.account-bg-container {
  position: relative;
  .account-bg {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(242, 242, 242, 0.7);

    .account-tip {
      position: fixed;
      width: 400px;
      text-align: center;
      top: 50%;
      left: 50%;
      transform: translate(-200px, 0);
      p {
        margin-bottom: 30px;
      }
      .account-tip-btn {
        margin-top: 20px;
        text-decoration: none;
        background-color: #2196f3;
        color: #fff;
        padding: 5px 10px;
        border-radius: 3px;
      }
    }
  }
}
</style>